import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1623332973942",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "233",
        "style": {
          "maxWidth": "628.609375px"
        },
        "viewBox": "0 0 628.609375 233"
      }}><style parentName="svg">{`#mermaid-1623332973942{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1623332973942 .error-icon{fill:#552222;}#mermaid-1623332973942 .error-text{fill:#552222;stroke:#552222;}#mermaid-1623332973942 .edge-thickness-normal{stroke-width:2px;}#mermaid-1623332973942 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1623332973942 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1623332973942 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1623332973942 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1623332973942 .marker{fill:#333333;stroke:#333333;}#mermaid-1623332973942 .marker.cross{stroke:#333333;}#mermaid-1623332973942 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1623332973942 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1623332973942 .cluster-label text{fill:#333;}#mermaid-1623332973942 .cluster-label span{color:#333;}#mermaid-1623332973942 .label text,#mermaid-1623332973942 span{fill:#333;color:#333;}#mermaid-1623332973942 .node rect,#mermaid-1623332973942 .node circle,#mermaid-1623332973942 .node ellipse,#mermaid-1623332973942 .node polygon,#mermaid-1623332973942 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1623332973942 .node .label{text-align:center;}#mermaid-1623332973942 .node.clickable{cursor:pointer;}#mermaid-1623332973942 .arrowheadPath{fill:#333333;}#mermaid-1623332973942 .edgePath .path{stroke:#333333;stroke-width:1.5px;}#mermaid-1623332973942 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1623332973942 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1623332973942 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1623332973942 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1623332973942 .cluster text{fill:#333;}#mermaid-1623332973942 .cluster span{color:#333;}#mermaid-1623332973942 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80,100%,96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1623332973942 .node rect,#mermaid-1623332973942 .node circle,#mermaid-1623332973942 .node polygon,#mermaid-1623332973942 .node path{stroke-width:2px;stroke:#3f20ba;fill:#F4F6F8;}#mermaid-1623332973942 .node.secondary rect,#mermaid-1623332973942 .node.secondary circle,#mermaid-1623332973942 .node.secondary polygon,#mermaid-1623332973942 .node.tertiary rect,#mermaid-1623332973942 .node.tertiary circle,#mermaid-1623332973942 .node.tertiary polygon{fill:white;}#mermaid-1623332973942 .node.secondary rect,#mermaid-1623332973942 .node.secondary circle,#mermaid-1623332973942 .node.secondary polygon{stroke:#f25cc1;}#mermaid-1623332973942 .cluster rect,#mermaid-1623332973942 .node.tertiary rect,#mermaid-1623332973942 .node.tertiary circle,#mermaid-1623332973942 .node.tertiary polygon{stroke:#41d9d3;}#mermaid-1623332973942 .cluster rect{fill:none;stroke-width:2px;}#mermaid-1623332973942 .label,#mermaid-1623332973942 .edgeLabel{background-color:white;line-height:1.3;}#mermaid-1623332973942 .edgeLabel rect{background:none;fill:none;}#mermaid-1623332973942 .messageText,#mermaid-1623332973942 .noteText,#mermaid-1623332973942 .loopText{font-size:12px;stroke:none;}#mermaid-1623332973942 g rect,#mermaid-1623332973942 polygon.labelBox{stroke-width:2px;}#mermaid-1623332973942 g rect.actor{stroke:#26a29d;fill:white;}#mermaid-1623332973942 g rect.note{stroke:#f25cc1;fill:white;}#mermaid-1623332973942 g line.loopLine,#mermaid-1623332973942 polygon.labelBox{stroke:#3f20ba;fill:white;}#mermaid-1623332973942:root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1623332973942 flowchart{fill:apa;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-webapp LE-gateway",
                "id": "L-webapp-gateway",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M242.5078125,186L242.5078125,161L280.78028441011236,136",
                  "markerEnd": "url(#arrowhead15)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead15",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-iosapp LE-gateway",
                "id": "L-iosapp-gateway",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M378.7578125,186L378.7578125,161L340.48534058988764,136",
                  "markerEnd": "url(#arrowhead16)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead16",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-serviceA",
                "id": "L-gateway-serviceA",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M260.4140625,106.24010043041606L92.8203125,72L92.8203125,47",
                  "markerEnd": "url(#arrowhead17)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead17",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-serviceB",
                "id": "L-gateway-serviceB",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M310.6328125,97L310.6328125,72L310.6328125,47",
                  "markerEnd": "url(#arrowhead18)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead18",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-serviceC",
                "id": "L-gateway-serviceC",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M360.8515625,106.41019400352734L532.1171875,72L532.1171875,47",
                  "markerEnd": "url(#arrowhead19)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead19",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-webapp-gateway",
                        "className": "edgeLabel L-LS-webapp' L-LE-gateway"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-iosapp-gateway",
                        "className": "edgeLabel L-LS-iosapp' L-LE-gateway"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-serviceA",
                        "className": "edgeLabel L-LS-gateway' L-LE-serviceA"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-serviceB",
                        "className": "edgeLabel L-LS-gateway' L-LE-serviceB"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-serviceC",
                        "className": "edgeLabel L-LS-gateway' L-LE-serviceC"
                      }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node tertiary",
                "id": "flowchart-webapp-13",
                "transform": "translate(242.5078125,205.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-45.046875",
                  "y": "-19.5",
                  "width": "90.09375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-35.046875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "70.09375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Web app`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node tertiary",
                "id": "flowchart-iosapp-14",
                "transform": "translate(378.7578125,205.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "5",
                  "ry": "5",
                  "x": "-41.203125",
                  "y": "-19.5",
                  "width": "82.40625",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-31.203125,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "62.40625",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`iOS app`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-gateway-15",
                "transform": "translate(310.6328125,116.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "19.5",
                  "ry": "19.5",
                  "x": "-50.21875",
                  "y": "-19.5",
                  "width": "100.4375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-35.34375,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "70.6875",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Gateway`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceA-16",
                "transform": "translate(92.8203125,27.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-84.8203125",
                  "y": "-19.5",
                  "width": "169.640625",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-74.8203125,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "149.640625",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Products subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceB-17",
                "transform": "translate(310.6328125,27.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-82.9921875",
                  "y": "-19.5",
                  "width": "165.984375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-72.9921875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "145.984375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Reviews subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-serviceC-18",
                "transform": "translate(532.1171875,27.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-88.4921875",
                  "y": "-19.5",
                  "width": "176.984375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-78.4921875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "156.984375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Inventory subgraph`}</div></foreignObject></g></g></g></g></g></g></svg></div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      